module.exports = __webpack_public_path__ + "img/yunzhensuo.47c9a788.png";